import { render, staticRenderFns } from "./step.vue?vue&type=template&id=5b5ac37b&scoped=true&"
import script from "./step.vue?vue&type=script&lang=ts&"
export * from "./step.vue?vue&type=script&lang=ts&"
import style0 from "./step.vue?vue&type=style&index=0&id=5b5ac37b&lang=scss&scoped=true&"
import style1 from "./step.vue?vue&type=style&index=1&id=5b5ac37b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ac37b",
  null
  
)

export default component.exports